import {endpointKeys, PractitionerIdParam} from '@common/api'
import {
  PractitionerTimeOff,
  UpsertPractitionerTimeOffRequest,
} from '@common/models'

import {useApi, useWebGet, useWebSet} from './helpers'

/**
 * Hooks for Practitioner Time Off (Partner Admin scope)
 * Base path: /api/v1/partner-administrators/practitioners/{practitionerId}/time-off
 */

export const useGetPractitionerTimeOff = (params: PractitionerIdParam) =>
  useWebGet<PractitionerTimeOff[]>(
    [endpointKeys.partnerAdminPractitionerTimeOff, params],
    useApi().partnerAdminPractitionerTimeOff(params),
    (data) => data,
  )

export const useCreatePractitionerTimeOff = (params: PractitionerIdParam) =>
  useWebSet<UpsertPractitionerTimeOffRequest, PractitionerTimeOff>(
    [endpointKeys.partnerAdminPractitionerTimeOff, params],
    useApi().partnerAdminPractitionerTimeOff(params),
    'POST',
    (data) => data,
    [
      [endpointKeys.partnerAdminPractitionerTimeOff, params],
      [endpointKeys.partnerAdminPractitionersTimeOff],
      [endpointKeys.partnerAdminPractitionerAvailability],
      [
        endpointKeys.partnerAdminPractitionerAvailability,
        {practitionerId: params.practitionerId},
      ],
    ],
  )

export const useUpdatePractitionerTimeOff = (
  params: PractitionerIdParam & {id: string},
) =>
  useWebSet<UpsertPractitionerTimeOffRequest, PractitionerTimeOff>(
    [endpointKeys.partnerAdminPractitionerTimeOffItem, params],
    useApi().partnerAdminPractitionerTimeOffItem(params),
    'PUT',
    (data) => data,
    [
      [
        endpointKeys.partnerAdminPractitionerTimeOff,
        {practitionerId: params.practitionerId},
      ],
      [endpointKeys.partnerAdminPractitionersTimeOff],
      [endpointKeys.partnerAdminPractitionerAvailability],
      [
        endpointKeys.partnerAdminPractitionerAvailability,
        {practitionerId: params.practitionerId},
      ],
    ],
  )

export const useDeletePractitionerTimeOff = (
  params: PractitionerIdParam & {id: string},
) =>
  useWebSet<void, void>(
    [endpointKeys.partnerAdminPractitionerTimeOffItem, params],
    useApi().partnerAdminPractitionerTimeOffItem(params),
    'DELETE',
    (data) => data,
    [
      [
        endpointKeys.partnerAdminPractitionerTimeOff,
        {practitionerId: params.practitionerId},
      ],
      [endpointKeys.partnerAdminPractitionersTimeOff],
      [endpointKeys.partnerAdminPractitionerAvailability],
      [
        endpointKeys.partnerAdminPractitionerAvailability,
        {practitionerId: params.practitionerId},
      ],
    ],
  )
